import { IUserSearch } from './../../../../share/types/user';
import * as React from "react";
import { toastr } from 'react-redux-toastr';
import { ManagersService } from "src/share/services/managers";
import { IManager } from "src/share/types/manager";

export const useUsers = (options: IUserSearch): IUsersReturned => {
  const [users, setUsers] = React.useState<IManager[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [total, setTotal] = React.useState(0);
  async function getUsers(): Promise<void> {
    try {
      setIsLoading(true);
      const { managers, total: count } = await ManagersService.search(options);
      setUsers(prevUsers => (options.isAppended ? [...prevUsers, ...managers] : managers));
      setTotal(count);
      setIsLoading(false);
    } catch {
      setIsLoading(false);
      setUsers([]);
      toastr.error('Users', 'There was a problem loading the users');
    }
  }
  React.useEffect(() => {
    getUsers();
  }, [options]);
  return { users, total, isLoading };
}

interface IUsersReturned { users: IManager[]; total: number; isLoading: boolean }